/**
 * Retrieval Source Limits
 *
 * Shared source-count caps for chat and space retrieval.
 *
 * Primary responsibilities:
 * - Map normalized Losi plans to retrieval source limits
 * - Keep client controls and API caps aligned
 *
 * Dependencies:
 * - Losi pricing plan normalization
 */

import {
  getEffectiveFeaturePlanId,
  type FeaturePlanProfileLike,
  type LosiPublicPlanId
} from '@/lib/billing/losi-pricing'

export const MAX_FREE_RETRIEVAL_SOURCES = 5
export const MAX_PLUS_RETRIEVAL_SOURCES = 10
export const MAX_PRO_RETRIEVAL_SOURCES = 15
export const MAX_ULTRA_RETRIEVAL_SOURCES = 64
export const MAX_SPACE_RETRIEVAL_SOURCES = 64

export const RETRIEVAL_SOURCE_LIMITS_BY_PLAN: Record<LosiPublicPlanId, number> = {
  free: MAX_FREE_RETRIEVAL_SOURCES,
  plus: MAX_PLUS_RETRIEVAL_SOURCES,
  pro: MAX_PRO_RETRIEVAL_SOURCES,
  ultra: MAX_ULTRA_RETRIEVAL_SOURCES,
  business_starter: MAX_ULTRA_RETRIEVAL_SOURCES,
  business_pro: MAX_ULTRA_RETRIEVAL_SOURCES,
  business_ultra: MAX_ULTRA_RETRIEVAL_SOURCES,
  enterprise: MAX_ULTRA_RETRIEVAL_SOURCES
}

// --------------

export const getRetrievalSourceLimit = (
  profile: FeaturePlanProfileLike | null | undefined
) => {
  const planId = getEffectiveFeaturePlanId(profile)
  return RETRIEVAL_SOURCE_LIMITS_BY_PLAN[planId] ?? MAX_FREE_RETRIEVAL_SOURCES
}
